import React, { useEffect, useState } from "react"
import { getStockRightFSData,  } from "../../../modules/quote/web"
import "./index.less"
import { getLongDataScaleClass, quote_fs_trade_info, quote_item_fs_trade_info, quote_item_name, quote_item_trade_info, quote_trade_info, single_quote } from "../../shared/quotedata/index"
import { store } from "./store"
import { Observer } from "mobx-react-lite"
import { quotedata } from "../../shared/quotedata"
import { LoadStatus } from "../../shared/load_status"
import { isShortTermBond } from "../../shared/pagetype"

export function GlobalBondTimeTrade(props: { quotedata: quotedata }) {
  return (
    <div className="content-hq">
      <SellAndBuy />
      <FSTrade quotedata={props.quotedata} />
    </div>
  )
}

function SellAndBuy() {
  return (
    <Observer>
      {() => (
        <>
          <ul className="tb-sell">
            <li>
              <span className={getLongDataScaleClass(380,"")}>最优买</span>
              &nbsp;&nbsp;&nbsp;
              {quote_trade_info[quote_item_trade_info.买1价](store.StockDetail).tips_element}
              {single_quote[quote_item_name.国债最优买YTM](store.StockDetail).element}
            </li>
          </ul>
          <ul className="tb-buy">
            <li>
              <span className={getLongDataScaleClass(380,"")}>最优卖</span>
              &nbsp;&nbsp;&nbsp;
              {quote_trade_info[quote_item_trade_info.卖1价](store.StockDetail).tips_element}
              {single_quote[quote_item_name.国债最优卖YTM](store.StockDetail).element}
            </li>
          </ul>
        </>
      )}
    </Observer>
  )
}

function FSTrade(props: { quotedata: quotedata }) {
  const [tradeData, setTradeData] = useState<Array<string>>([])
  const [lastItem, setLastItem] = useState<string>("")
  useEffect(() => {
    ;(async () => {
      let result = await getStockRightFSData(props.quotedata.quotecode,16)
      setLastItem(result[result.length - 1])
      setTradeData(result.slice(0, 16))
    })()
  }, [])

  return (
    <ul className="tb-fenshi">
      <li>
        <span>时</span>
        <span>价</span>
        <span>YTM</span>
      </li>
      <>
        {tradeData.length > 0 &&
          tradeData.map((item: any, index: number) => {
            return (
              <li key={index}>
                {quote_fs_trade_info[quote_item_fs_trade_info.时间](item).element}
                {quote_fs_trade_info[quote_item_fs_trade_info.成交价](tradeData, lastItem, item, index, store.StockDetail, 15).element}
                {isShortTermBond(store.StockDetail)?quote_fs_trade_info[quote_item_fs_trade_info.国债YTM](item, store.StockDetail).short_term_bond_element:quote_fs_trade_info[quote_item_fs_trade_info.国债YTM](item, store.StockDetail).element}
              </li>
            )
          })}
          {
            tradeData.length == 0 && <LoadStatus icon={false} title="暂无数据" className="time-trade-tips"/>
          }
      </>
    </ul>
  )
}
